import { render, staticRenderFns } from "./orderInfoByAdmin.vue?vue&type=template&id=ea2db932&scoped=true&"
import script from "./orderInfoByAdmin.vue?vue&type=script&lang=js&"
export * from "./orderInfoByAdmin.vue?vue&type=script&lang=js&"
import style0 from "./orderInfoByAdmin.vue?vue&type=style&index=0&id=ea2db932&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2db932",
  null
  
)

export default component.exports